module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8dce2d7771264c77592cb6fc0c778101.png";